import { faSpinnerThird } from '@awesome.me/kit-e215ba4646/icons/sharp/light'
import { Icon, type IconProps } from '@/components/ui/icon'
import { cn } from '@/lib/utils'

/**
 * The one loading spinner (user, 2026-11-02: one look everywhere). ShadCN's
 * `Spinner` (new-york-v4) with its lucide `Loader2Icon` swapped for the
 * matching Font Awesome open arc. Size and colour come from `className`.
 */
export function Spinner({ className, ...props }: Omit<IconProps, 'icon'>) {
  return (
    <Icon
      icon={faSpinnerThird}
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  )
}
